import React, { useContext } from "react";
import GlobalContext from "../../context/global";
import DisclaimerText from "./DisclaimerText";

const DisclaimerCDTT = () => {
  const appData = useContext(GlobalContext);
  const { isCDTT } = appData;

  return (
    <div className="row">
      <div className="col-12 mt-2 mb-4 cdtt-disclaimer lh-sm">
        <p>
          <DisclaimerText isCDTT={isCDTT} />
        </p>
      </div>
    </div>
  );
};

export default DisclaimerCDTT;
